var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg044Email(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#72CDA2"
    },
    d: "M464.939,368.773L98.235,433.434c-26.039,4.591-50.868-12.795-55.459-38.833 L8.231,198.687c-4.591-26.039,12.795-50.868,38.833-55.459l366.704-64.66c26.039-4.591,50.868,12.795,55.459,38.833 l34.545,195.914C508.363,339.353,490.977,364.182,464.939,368.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#72CDA2"
    },
    d: "M464.939,368.773L98.235,433.434 c-26.039,4.591-50.868-12.795-55.459-38.833L8.231,198.687c-4.591-26.039,12.795-50.868,38.833-55.459l366.704-64.66 c26.039-4.591,50.868,12.795,55.459,38.833l34.545,195.914C508.363,339.353,490.977,364.182,464.939,368.773z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_2_",
    style: {
      fill: "#7F9AE6"
    },
    d: "M464.939,368.773L98.235,433.434c-26.039,4.591-50.868-12.795-55.459-38.833 L8.231,198.687c-4.591-26.039,12.795-50.868,38.833-55.459l366.704-64.66c26.039-4.591,50.868,12.795,55.459,38.833l34.545,195.914 C508.363,339.353,490.977,364.182,464.939,368.773z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7BAB"
    },
    d: "M98.235,433.434l366.704-64.66c18.047-3.182,31.932-16.091,37.229-32.383l-207.682-128.06 l-90.951,16.037L52.176,415.736C62.726,429.234,80.188,436.616,98.235,433.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0F1"
    },
    d: "M280.602,278.222L458.199,94.288c-10.664-12.233-27.285-18.743-44.432-15.719L47.064,143.227 c-17.147,3.023-30.539,14.826-36.376,29.969l229.796,112.1C253.978,291.877,270.174,289.022,280.602,278.222z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.1736 -0.9848 0.9848 -0.1736 -11.0001 392.1728)",
    style: {
      fill: "#E38892"
    },
    cx: 159.044,
    cy: 200.702,
    rx: 25.23,
    ry: 31.683
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1736 0.9848 -0.9848 0.1736 439.4878 -182.0089)",
    style: {
      fill: "#E38892"
    },
    cx: 328.194,
    cy: 170.864,
    rx: 25.23,
    ry: 31.683
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M423.077,77.849c-0.851-0.017-1.706-0.008-2.563,0.021 C421.371,77.841,422.226,77.832,423.077,77.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M504.381,325.066 c-77.067,13.608-149.931,23.353-212.681,1.366c-6.812-2.387-8.652-11.001-3.614-16.17c0.042-0.043,0.084-0.086,0.125-0.129 l181.8-188.287l-0.784-4.445c-1.568-8.891-5.498-16.77-11.027-23.114L280.602,278.221c-10.428,10.8-26.625,13.656-40.118,7.074 l-61.644-30.072c-31.912-35.597-47.754-79.456-40.034-128.173l-91.742,16.176c-26.039,4.591-43.424,29.422-38.833,55.459 L42.776,394.6c4.591,26.039,29.422,43.425,55.459,38.833l366.704-64.66C487.008,364.882,502.857,346.45,504.381,325.066z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M429.054,78.351c-0.694-0.102-1.391-0.188-2.092-0.259 C427.663,78.163,428.361,78.249,429.054,78.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M419.636,77.912c-0.701,0.037-1.403,0.089-2.107,0.157 C418.232,78.002,418.935,77.949,419.636,77.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M426.195,78.013c-0.937-0.08-1.879-0.139-2.828-0.164 C424.316,77.874,425.258,77.933,426.195,78.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M449.265,86.316c0.784,0.541,1.553,1.104,2.303,1.69 C450.818,87.42,450.049,86.857,449.265,86.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M432.236,78.927c-0.78-0.169-1.565-0.319-2.356-0.449 C430.671,78.608,431.457,78.758,432.236,78.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M416.666,78.155c-0.964,0.111-1.93,0.241-2.898,0.412 C414.735,78.396,415.702,78.266,416.666,78.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M448.894,86.069c-0.649-0.439-1.308-0.861-1.977-1.268 C447.587,85.208,448.246,85.631,448.894,86.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M455.889,91.832c-0.556-0.554-1.125-1.093-1.707-1.618 C454.764,90.739,455.333,91.279,455.889,91.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M453.71,89.791c-0.641-0.563-1.294-1.112-1.963-1.64 C452.416,88.679,453.07,89.228,453.71,89.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M435.341,79.709c-0.897-0.259-1.802-0.496-2.717-0.703 C433.539,79.213,434.444,79.45,435.341,79.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M458.199,94.288c-0.635-0.728-1.293-1.432-1.969-2.119 C456.906,92.855,457.565,93.56,458.199,94.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M446.326,84.448c-0.677-0.398-1.364-0.78-2.06-1.145 C444.963,83.668,445.649,84.05,446.326,84.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M443.875,83.093c-0.837-0.429-1.686-0.834-2.548-1.213 C442.189,82.26,443.038,82.664,443.875,83.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M438.028,80.579c-0.689-0.244-1.384-0.472-2.085-0.684 C436.644,80.107,437.34,80.335,438.028,80.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#2C6245",
      enableBackground: "new"
    },
    d: "M440.929,81.713c-0.718-0.309-1.444-0.599-2.178-0.872 C439.485,81.114,440.211,81.404,440.929,81.713z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.447,184.72c5.155,4.164,11.536,6.387,18.054,6.387c1.657,0,3.324-0.144,4.98-0.436 c8.171-1.441,15.318-6.351,19.609-13.47c2.138-3.547,0.995-8.157-2.553-10.295c-3.547-2.139-8.157-0.995-10.295,2.553 c-2.052,3.404-5.466,5.751-9.366,6.439c-3.902,0.687-7.913-0.35-11.004-2.848c-3.222-2.602-7.944-2.102-10.547,1.122 C217.723,177.394,218.225,182.117,221.447,184.72z M290.372,157.164c0.432,0,0.871-0.038,1.311-0.115 c4.08-0.72,6.803-4.609,6.084-8.688c-0.726-4.116,2.032-8.056,6.148-8.781c4.116-0.724,8.057,2.032,8.782,6.148 c0.72,4.08,4.61,6.807,8.689,6.084c4.08-0.72,6.803-4.609,6.084-8.688c-2.163-12.262-13.903-20.474-26.16-18.316 c-12.262,2.163-20.478,13.897-18.316,26.159C283.635,154.604,286.8,157.164,290.372,157.164z M188.629,175.221 c4.08-0.719,6.803-4.609,6.084-8.688c-2.163-12.262-13.903-20.476-26.159-18.316c-12.261,2.162-20.478,13.896-18.317,26.159 c0.642,3.639,3.806,6.2,7.377,6.2c0.432-0.001,0.871-0.038,1.311-0.115c4.08-0.719,6.803-4.609,6.085-8.688 c-0.726-4.117,2.033-8.056,6.149-8.782c4.115-0.725,8.056,2.032,8.781,6.148C180.66,173.216,184.548,175.941,188.629,175.221z  M511.159,312.012l-25.32-143.597c-0.719-4.079-4.604-6.8-8.688-6.084c-4.079,0.719-6.803,4.609-6.084,8.689l25.32,143.597 c0.578,3.279,0.733,6.535,0.519,9.717l-156.954-96.78L457.31,106.007c2.157,3.849,3.723,8.111,4.531,12.696l3.156,17.896 c0.72,4.079,4.611,6.806,8.689,6.084c4.08-0.72,6.803-4.609,6.084-8.688l-3.156-17.896c-2.568-14.566-10.655-27.261-22.772-35.745 c-12.116-8.484-26.812-11.74-41.377-9.173l-366.705,64.66c-19.562,3.449-34.918,16.838-41.807,34.052 c-0.003,0.005-0.006,0.01-0.008,0.015c-0.187,0.383-0.329,0.774-0.446,1.169c-3.343,8.94-4.431,18.851-2.657,28.913l34.545,195.913 c2.568,14.566,10.655,27.261,22.772,35.745c9.414,6.592,20.384,10.029,31.643,10.028c3.23,0,6.486-0.283,9.733-0.855l366.704-64.66 c20.704-3.651,36.703-18.431,42.931-37.1c0.117-0.307,0.212-0.617,0.287-0.931C512.034,329.937,512.75,321.035,511.159,312.012z  M22.305,167.217c6.185-8.833,15.441-14.73,26.062-16.602l366.703-64.66c12.018-2.12,23.745,1.345,32.532,8.512l-124.962,129.42 c-0.009,0.009-0.018,0.018-0.027,0.028l-47.406,49.097c-8.195,8.489-20.827,10.716-31.434,5.543l-61.342-29.924 c-0.008-0.004-0.016-0.008-0.024-0.012L20.691,169.731C21.2,168.88,21.73,168.038,22.305,167.217z M463.637,361.387l-366.704,64.66 c-10.621,1.873-21.334-0.503-30.168-6.688c-1.709-1.197-3.305-2.511-4.787-3.926l18.711-23.658c2.57-3.249,2.019-7.966-1.229-10.535 c-3.248-2.569-7.965-2.019-10.535,1.229l-15.937,20.15c-1.297-2.947-2.252-6.07-2.825-9.322L15.617,197.385 c-0.799-4.531-0.818-9.078-0.105-13.49l151.874,74.087l-76.771,97.064c-2.57,3.249-2.019,7.966,1.23,10.535 c1.377,1.089,3.018,1.618,4.647,1.618c2.214,0,4.407-0.977,5.887-2.848l78.806-99.637l56.009,27.323 c5.919,2.887,12.243,4.29,18.509,4.29c11.164,0,22.142-4.454,30.293-12.895l43.287-44.832l163.546,100.844 C487.328,350.589,476.787,359.069,463.637,361.387z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg044Email);
export default __webpack_public_path__ + "static/media/044-email.c29e7f52099d6872ad9aa07187c5dc8b.svg";
export { ForwardRef as ReactComponent };